import Super from 'client-portal/routes/-request/clinician-search';

export default class WidgetClinicianSearch extends Super {}
